<template functional>
  <span
    class="cell-bool-icon"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class]"
  >
    <decor-icon
      v-if="!!props.value"
      :icon="$options.yes(props)"
    ></decor-icon>

    <decor-icon
      v-else
      :icon="$options.no(props)"
    ></decor-icon>
  </span>
</template>

<script>
import ModuleBase from "./module-base";

export default {
  name: "CellBoolIcon",
  mixins: [ModuleBase],
  yes: (props) => {
    return props.column.format_data.yes || 'check'
  },
  no: (props) => {
    return props.column.format_data.no || 'times'
  }
};
</script>

<style lang="scss">
@import "@/style/inject";
</style>

